import Vue from "vue";

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN':     document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

Vue.config.devtools = 'development'; // TODO remove in production
